import React, { useEffect } from 'react';

import IntegrationsLists from '../components/integrations/IntegrationsLists.jsx';
import '../App.css';
import { useAuthContext } from '../contexts/AuthContext.jsx';
import { getEnrichedIntegrations } from '../data/integrations.js';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';

const IntegrationsContent = () => {
  const { currentOrganization, integrations, setIntegrations } = useAuthContext();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const enrichedData = await getEnrichedIntegrations(currentOrganization);
        setIntegrations(enrichedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (integrations) {
      fetchData();
    }
  }, []); // Empty dependency array means this effect runs once after the initial render

  const allAvailableIntegrations = integrations?.available || [];
  const needAttentionIntegrations = allAvailableIntegrations?.filter((i) => (i.connection_status === "active" && i.credential_status === "invalid" || i.unmapped_products > 0));
  const needAttentionIntegrationIds = needAttentionIntegrations?.map((i) => i.integration_id);
  const activeIntegrations = allAvailableIntegrations?.filter((i) => (i.connection_status === "active") && !needAttentionIntegrationIds.includes(i.integration_id));
  const availableIntegrations = allAvailableIntegrations?.filter((i) => i.connection_status === "new" || i.connection_status === null || i.connection_status === "configuring");
  const unavailableIntegrations = integrations?.unavailable || [];
  return (
    <>
      <div className="py-10">
        <main>
        { needAttentionIntegrations.length > 0 ?
            <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-2">
              <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900 pb-2">Need Attention</h1>
            </div>
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mb-10">
                <IntegrationsLists integrations={needAttentionIntegrations} /></div>
                </>
            : null
          }
          { activeIntegrations.length > 0 ?
            <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-2">
              <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900 pb-2">Active</h1>
            </div>
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mb-10">
                <IntegrationsLists integrations={activeIntegrations} /></div>
                </>
            : null
          }
          { (availableIntegrations.length > 0 || unavailableIntegrations.length > 0) ?
            <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900 pb-2">Available</h1>
            </div>
            </>
            : null
          }
          {
            availableIntegrations.length > 0 ?
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 mb-5">
                <IntegrationsLists integrations={availableIntegrations} /></div>
            : null
          }
          { unavailableIntegrations.length > 0 ?
            <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-2">
              <div className="flex items-center gap-x-1">
              <h1 className="text-1xl font-bold leading-tight tracking-tight text-gray-600 hover:text-gray-800 hover:underline cursor-pointer pr-2 flex items-center gap-1" id="support">
                <QuestionMarkCircleIcon className="h-4 w-4" />
                Contact Support to enable
              </h1>
              </div>
              
            </div>
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 opacity-60">
                <IntegrationsLists integrations={unavailableIntegrations} /></div>
                </>
            : null
          }
        </main>
      </div>
    </>
  );
};

export default function Integrations() {
  return (
    <IntegrationsContent  />
  );
}
